import * as tslib_1 from "tslib";
import trySaveMessage, { isSaving } from './trySaveMessage';
import { FileSelectionFilter, lazyAttachmentFilePicker } from 'owa-attachment-filepicker';
import { lazyGetAvailableLocalAttachmentSize } from 'owa-attachment-well-data';
import { action } from 'satcheljs/lib/legacy';
export default action('clickAttachButton')(function clickAttachButton(isInline, handler, viewState) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var maximumClassicAttachmentSize;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!viewState.itemId && !isSaving(viewState)) {
                        trySaveMessage(viewState);
                    }
                    return [4 /*yield*/, lazyGetAvailableLocalAttachmentSize.import()];
                case 1:
                    maximumClassicAttachmentSize = (_a.sent())(viewState.attachmentWell);
                    lazyAttachmentFilePicker.importAndExecute(handler, maximumClassicAttachmentSize, isInline ? FileSelectionFilter.Images : FileSelectionFilter.None);
                    return [2 /*return*/];
            }
        });
    });
});
//# sourceMappingURL=clickAttachButton.js.map